import { Injector, Injectable } from '@angular/core';

import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable()
export class CompanyInterceptor implements HttpInterceptor {
  constructor(private inj: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('/languages') > -1) {
      return next.handle(req);
    } else {
      const authService = this.inj.get(AuthService);
      const companyId = authService.getCompanyId();
      // Only add Company header if companyId exists and is not empty
      if (companyId && companyId.trim() !== '') {
        const clonedRequest = req.clone({ 
          setHeaders: {
            Company: companyId
          }
        });
        return next.handle(clonedRequest);
      }
      return next.handle(req);
    }
  }
}
